export default "__VITE_ASSET__zv_u1gKu__"